import * as selection from 'd3-selection'
import * as shape from 'd3-shape'
import * as scale from 'd3-scale'
import * as array from 'd3-array'
import * as axis from 'd3-axis'
import * as format from 'd3-time-format'
import * as time from 'd3-time'

export default Object.assign(
  {},
  selection,
  shape,
  scale,
  array,
  axis,
  format,
  time
)
